import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Accordion } from "react-bootstrap";
import { TitleContext } from "../../../Context/TitleContext";
import { API_URL, useAxios } from "../../../utils/const";
import { Toaster } from "react-hot-toast";
import CreateModal from "./CreateModal";
import UpdateModal from "./UpdateModal";
import { DeleteModal } from "./DeleteModal";
import excelJS from "exceljs";
import { saveAs } from "file-saver";
import { ImportModal } from "./ImportModal";
import Cookies from "js-cookie";
import { useAuth } from "../../../Context/AuthContext";
import { Fragment } from "react";

const Courses = () => {
  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();
  const { logout } = useAuth();

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);

  const [courses, setCourses] = useState({ courses: [], totalRecords: 0 });
  const [courseRecords, setCourseRecords] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);

  const [semesters, setSemesters] = useState([]);
  const [groups, setGroups] = useState([]);
  const [userRoles, setUserRoles] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userRole = Cookies.get("userRoles");
        setUserRoles(userRole);
      } catch (error) {
        logout();
      } finally {
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setTitle("USAKTI | Daftar Modul"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    getCourses();
    getSemesters();
    getGroups();
  }, []);

  const toggleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const toggleOpenUpdateModal = (e) => {
    setSelectedCourse(e);
    setOpenUpdateModal(true);
  };

  const toggleOpenDeleteModal = (e) => {
    setSelectedCourse(e);
    setOpenDeleteModal(true);
  };

  const toggleOpenImportModal = () => {
    setOpenImportModal(true);
  };

  const getCourses = async () => {
    const response = await axiosInstance.get(`${API_URL}/courses`);
    setCourses({
      courses: response.data.data,
      totalRecords: response.data.totalRecords,
    });
    setCourseRecords(response.data.data);
  };

  const getSemesters = async () => {
    const response = await axiosInstance.get(`${API_URL}/semesters`);
    setSemesters({
      semesters: response.data.data,
      totalRecords: response.data.totalRecords,
    });
  };

  const getGroups = async () => {
    const response = await axiosInstance.get(`${API_URL}/groups`);
    setGroups({
      groups: response.data.data,
      totalRecords: response.data.totalRecords,
    });
  };

  const exportTemplateExcel = async () => {
    // Create a new workbook
    const workbook = new excelJS.Workbook();
    // New Worksheet
    const worksheet = workbook.addWorksheet("Daftar Modul Template Excel");
    // Column for data in excel. key must match data key
    worksheet.columns = [
      { header: "KODE_MK", key: "kode_mk", width: 10 },
      { header: "NAMA_MODUL", key: "nama_modul", width: 10 },
      { header: "SKS", key: "sks", width: 10 },
      { header: "SEMESTER", key: "semester", width: 10 },
    ];

    // Making first line in excel bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      "Daftar Modul Template Excel.xlsx"
    );
  };

  const exportCourses = async () => {
    // Create a new workbook
    const workbook = new excelJS.Workbook();

    // New Worksheet
    const worksheet = workbook.addWorksheet("EXPORT_DATA_MODUL");

    // Column for data in excel. key must match data key
    worksheet.columns = [
      { header: "KODE_MODUL", key: "kode_mk", width: 12 },
      { header: "NAMA_MODUL", key: "name", width: 50 },
      { header: "SKS", key: "sks", width: 5 },
      { header: "SEMESTER", key: "semester", width: 12 },
    ];

    worksheet.getCell("A1").font = { bold: true };

    // Looping through courses data
    courseRecords.map((semester) => {
      semester.courses.map((course, index) => {
        worksheet.getCell("A1").alignment = {
          vertical: "middle",
          horizontal: "center",
        };

        // Add data in worksheet
        worksheet.addRow({
          kode_mk: course.kode_mk,
          name: course.name,
          sks: course.sks,
          semester: course.semester.name,
        });
      });
    });

    // Making first line in excel bold
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      "EXPORT_DATA_MODUL.xlsx"
    );
  };

  return (
    <div>
      <Toaster position="top-right" />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Daftar Modul</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Daftar Modul</li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            {userRoles !== "MAHASISWA" && (
              <div className="row">
                <div
                  className="col-md-12 d-flex gap-2"
                  style={{ justifyContent: "end" }}
                >
                  <Dropdown>
                    <Dropdown.Toggle variant="primary">
                      Export/Import
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={exportCourses}>
                        Export
                      </Dropdown.Item>
                      <Dropdown.Item onClick={toggleOpenImportModal}>
                        Import
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={exportTemplateExcel}>
                        Download Template
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <button
                    className="btn btn-success"
                    onClick={toggleOpenCreateModal}
                  >
                    + Tambah
                  </button>
                </div>
              </div>
            )}

            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>Daftar Modul</h4>
              </div>
            </div>

            <Accordion className="mt-3">
              {courseRecords.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>Semester {item.name}</Accordion.Header>
                  <Accordion.Body>
                    <div className="table-responsive">
                      <table className="table table-striped table-borderless" W>
                        <thead>
                          <tr>
                            <th>Kode MK</th>
                            <th>Modul</th>
                            <th>Kelompok Modul</th>
                            <th>SKS</th>
                            <th>Total Peserta</th>
                            <th>Aksi</th>
                          </tr>
                        </thead>
                        <tbody style={{ borderTop: "2px solid black" }}>
                          {item.courses.map((course, courseIndex) => (
                            <tr key={courseIndex}>
                              <td>{course.kode_mk}</td>
                              <td>{course.name}</td>
                              <td>
                                {course.courseGroups.length > 0
                                  ? course.courseGroups
                                      .map(
                                        (courseGroup, courseGroupIndex) =>
                                          courseGroup.group.name
                                      )
                                      .join(", ")
                                  : "-"}
                              </td>
                              <td className="text-center">{course.sks}</td>
                              <td className="text-center">
                                {course.courseTotalParticipants.length > 0 ? course.courseTotalParticipants[0].total_participants : 0}
                              </td>
                              <td>
                                {userRoles === "MAHASISWA" ? (
                                  // Jika peran adalah "MAHASISWA", hanya tampilkan tombol dengan ikon mata
                                  <Link
                                    to={`/akademik/course-attendance/history/${course.id}`}
                                    state={{ data: course }}
                                    className="btn btn-info text-white btn-sm"
                                  >
                                    <i className="fas fa-eye"></i>
                                  </Link>
                                ) : (
                                  // Jika bukan "MAHASISWA", tampilkan semua tombol
                                  <Fragment>
                                    <Link
                                      to={{
                                        pathname: `/akademik/courses/${course.id}`,
                                      }}
                                      state={{
                                        ...course,
                                        semester: item.semester,
                                      }}
                                      className="btn btn-info text-white btn-sm"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </Link>
                                    <button
                                      className="btn btn-warning text-white btn-sm"
                                      onClick={() =>
                                        toggleOpenUpdateModal(course)
                                      }
                                    >
                                      <i className="fas fa-pen-to-square"></i>
                                    </button>
                                    <button
                                      className="btn btn-danger text-white btn-sm"
                                      onClick={() =>
                                        toggleOpenDeleteModal(course)
                                      }
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </Fragment>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
        {openCreateModal && (
          <CreateModal
            toggleModal={setOpenCreateModal}
            getCourses={getCourses}
            semesters={semesters}
            groups={groups}
          />
        )}
        {openUpdateModal && (
          <UpdateModal
            toggleModal={setOpenUpdateModal}
            getCourses={getCourses}
            semesters={semesters}
            groups={groups}
            course={selectedCourse}
          />
        )}
        {openDeleteModal && (
          <DeleteModal
            toggleModal={setOpenDeleteModal}
            getCourses={getCourses}
            course={selectedCourse}
          />
        )}
        {openImportModal && (
          <ImportModal
            toggleModal={setOpenImportModal}
            getCourses={getCourses}
          />
        )}
      </div>
    </div>
  );
};

export default Courses;
